<template>
  <div class="container">
    <div class="products shadow p-4 my-4 mt-5">
      <div class="d-flex justify-content-between my-3">
        <h4>Products Table</h4>
        <button class="btn btn-primary" @click="showAddModal">Add New</button>
      </div>
      <table class="table b-table table-bordered text-left">
        <thead class="thead-light">
          <tr>
            <th>Name</th>
            <th>Price</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="product in products" :key="product.id">
            <td>{{ product.name }}</td>
            <td>{{ product.price }}</td>
            <td>
              <button class="btn btn-primary btn-sm" @click="showEditModal(product)">Edit</button>
              <button class="btn btn-danger btn-sm ml-2" @click="showDeleteModal(product.id)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- add product modal -->
    <b-modal id="add-product-modal" ref="modal" title="Add New Product" hide-footer size="xl">
      <form ref="form">
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Name">
              <b-form-input v-model="product.name" required></b-form-input>
            </b-form-group>
            <b-form-group label="price">
              <b-form-input v-model="product.price" required></b-form-input>
            </b-form-group>
            <vue-editor v-model="product.description" class="mb-3"></vue-editor>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Tags">
              <div class="d-flex mb-2">
                <b-form-input v-model="tag" @keyup.enter="addTag"></b-form-input>
                <button type="button" @click="addTag" class="btn btn-primary rounded-0">Add</button>
              </div>
              <div class="tags">
                <b-badge
                  pill
                  variant="dark"
                  class="px-3 py-2 mr-1 my-1"
                  v-for="(tag, index) in product.tags"
                  :key="index"
                >
                  {{ tag }}
                  <span
                    class="ml-2 d-inline-block p-1"
                    style="cursor:pointer"
                    @click="deleteTag(index)"
                  >x</span>
                </b-badge>
              </div>
            </b-form-group>

            <b-form-group class="input-file">
              <i class="fas fa-spinner fa-spin" v-if="loadingImg"></i>
              <b-form-file
                v-model="image"
                placeholder="Choose an image or drop it here..."
                drop-placeholder="Drop image here..."
                accept="image/*"
                @change="uploadImage"
                :disabled="loadingImg"
              ></b-form-file>
            </b-form-group>
            <div class="d-flex">
              <div v-for="(img, index) in product.images"
                :key="index"
                class="product-image ml-2">
                <img
                
                width="100"
                :src="img"
                alt="product-image"
              />
              <i class="fas fa-times remove" @click="deleteImage(img, index)"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- moal actions -->
        <div class="d-flex">
          <div class="mr-auto"></div>
          <button
            class="btn btn-danger mt-3"
            @click="$bvModal.hide('add-product-modal')"
            type="button"
          >cancel</button>
          <button
            type="button"
            class="btn btn-success mt-3 ml-2"
            @click="handleOk"
            v-if="modalMode == 'new'"
          >
            <span>Add</span>
            <b-spinner small v-if="loading" class="ml-2"></b-spinner>
          </button>

          <button
            type="button"
            class="btn btn-success mt-3 ml-2"
            @click.prevent="editProduct"
            v-if="modalMode == 'edit'"
          >
            <span>Save changes</span>
            <b-spinner small v-if="loading" class="ml-2"></b-spinner>
          </button>
        </div>
      </form>
    </b-modal>
    <!-- delete product modal -->
    <b-modal id="delete-product-modal" ref="delete-modal" title="Delete product" hide-footer>
      <p>Are You sure ?</p>
      <div class="d-flex">
        <div class="mr-auto"></div>
        <button class="btn btn-danger mt-3" @click="$bvModal.hide('delete-product-modal')">cancel</button>
        <button class="btn btn-success mt-3 ml-2" @click="deleteProduct">
          <span>Delete</span>
          <b-spinner small v-if="loading" class="ml-2"></b-spinner>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { fb } from "../../firebase";
import { firestore } from "../../firebase";

import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      products: [],
      product: {
        name: "",
        price: "",
        description: "",
        tags: [],
        images: []
      },
      tag: "",
      image: null,
      loadingImg: false,
      activeProduct: null,
      modalMode: "new",
      loading: false
    };
  },
  components: {
    VueEditor
  },
  firestore() {
    return {
      // read data from fire store
      products: firestore.collection("products")
    };
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    resetModal() {
      this.product.name = "";
      this.product.price = "";
      this.product.description = "";
      this.product.tags = [];
      this.product.images = [];
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.addNewProduct();
    },
    makeToast(msg, title, type) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: type,
        solid: true
      });
    },

    showAddModal() {
      this.resetModal();
      this.$refs.modal.show();
      this.modalMode = "new";
    },
    addNewProduct: function() {
      this.loading = true;
      this.$firestore.products
        .add(this.product)
        .then(() => {
          // console.log(res);
          this.loading = false;
          this.resetModal();
          this.$refs.modal.hide();
          this.makeToast("Product added successfully", "Alert", "success");
        })
        .catch(() => {
          // console.log(err);
        });
    },
    deleteProduct() {
      this.loading = true;
      this.$firestore.products
        .doc(this.activeProduct)
        .delete()
        .then(() => {
          this.loading = false;
          this.$refs["delete-modal"].hide();
          this.makeToast("Product deleted successfully", "Alert", "success");
          // console.log(this.activeProduct, "deleted successfully");
        })
        .catch(() => {
          // console.log(err);
        });
    },
    showDeleteModal(id) {
      this.$refs["delete-modal"].show();
      // console.log(id);
      this.activeProduct = id;
    },
    showEditModal(product) {
      this.product = {
        ...product
      };
      this.activeProduct = product.id;
      // console.log(this.activeProduct);
      this.$refs.modal.show();
      this.modalMode = "edit";
    },
    editProduct() {
      if (this.checkFormValidity()) {
        this.loading = true;
        this.$firestore.products
          .doc(this.activeProduct)
          .update(this.product)
          .then(() => {
            // console.log("Product updated successfully");
            this.loading = false;
            this.$refs.modal.hide();
            this.makeToast("Product updated successfully", "Alert", "success");
          })
          .catch(() => {
            // console.log(err);
          });
      }
    },
    addTag() {
      this.product.tags.push(this.tag);
      this.tag = "";
    },
    deleteTag(index) {
      this.product.tags.splice(index, 1);
    },
    uploadImage(e) {
      let image = e.target.files[0];
      // console.log(image);
this.loadingImg = true;
      var uploadTask = fb.storage().ref("products/" + Math.random().toString().slice(2) + image.name).put(image);

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          // var progress =
          //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case fb.storage.TaskState.PAUSED: // or 'paused'
              // console.log("Upload is paused");
              break;
            case fb.storage.TaskState.RUNNING: // or 'running'
              // console.log("Upload is running");
              break;
          }
        },
        () => {
          // Handle unsuccessful uploads
          // console.log("failed to upload the image", error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // console.log("File available at", downloadURL);
            this.product.images.push(downloadURL);
            this.loadingImg = false;
          });
        }
      );
    },

    deleteImage(imgUrl, index) {
      fb.storage().refFromURL(imgUrl).delete()
      .then(() => {
        // console.log("deleted successfully");
        this.product.images.splice(index, 1);
      }).catch(() => {
        // console.log("failed to delete the image");
      })
    }
  }
};
</script>


<style scoped lang="scss">
.products {
  background: #fff;
}
.product-image {
  position: relative;
  .remove {
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px 7px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    cursor: pointer;
    font-size: 12px;
  }
}

.input-file {
  position: relative;
  i {
    position: absolute;
    top: 12px;
    right: 85px;
    z-index: 2;
  }
}
</style>